import i18n from '@/plugins/i18n'
import CardHeader from './components/CardHeader'
import CreateButton from './components/CreateButton'
import EditButton from './components/EditButton'
import DeleteButton from './components/DeleteButton'
import BreadCrumb from './components/BreadCrumb'
import ConfirmDelete from './components/ConfirmDelete'
import sharedLocale from './i18n/locales/pt-br'

const MyPlugin = {}
MyPlugin.install = function(Vue) {
    Vue.component('breadcrumb', BreadCrumb)
    Vue.component('card-header', CardHeader)
    Vue.component('create-btn', CreateButton)
    Vue.component('delete-btn', DeleteButton)
    Vue.component('confirm-delete', ConfirmDelete)
    Vue.component('edit-btn', EditButton)

    i18n.mergeLocaleMessage('pt-br', sharedLocale) // Por enquanto pt-br estático

    // // 1. add global method or property
    // Vue.myGlobalMethod = function () {
    //   // some logic ...
    // }
    // // 2. add a global asset
    // Vue.directive('my-directive', {
    //   bind (el, binding, vnode, oldVnode) {
    //     // some logic ...
    //   }
    // })
    // // 3. inject some component options
    // Vue.mixin({
    //   created: function () {
    //     // some logic ...
    //   }
    // })
    // 4. add an instance method
    // Vue.prototype.$teste = function (methodOptions) {
    // }
}
export default MyPlugin
